import ResponsiveTypography from '@/components/ui/responsive-typography';
import {Box, useMediaQuery, useTheme} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import {useTranslation} from 'react-i18next';
import {alpha} from '@mui/material';
import {BoxPosition} from '@/types/matrix';

const borderRadius = {
  single: {
    borderTopRightRadius: '16px',
    borderBottomRightRadius: '16px',
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px'
  },
  last: {
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '18px',
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '18px'
  }
};

interface MultimediaLoadingBoxProps {
  multimediaCount: number;
  boxPosition: BoxPosition;
}

const MultimediaLoadingBox: React.FC<MultimediaLoadingBoxProps> = ({
  multimediaCount,
  boxPosition
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const {t} = useTranslation();

  const loadingLabel = multimediaCount > 1 ? 'loading_media' : 'loading_medium';

  let dimensions = {width: '300px', height: '300px'};

  switch (multimediaCount) {
    case 1:
      dimensions = isSmallScreen
        ? {width: '150px', height: '150px'}
        : {width: '300px', height: '300px'};
      break;
    case 2:
      dimensions = isSmallScreen
        ? {width: '150px', height: '75px'}
        : {width: '300px', height: '150px'};
      break;
    case 3:
      dimensions = isSmallScreen
        ? {width: '200px', height: '100px'}
        : {width: '300px', height: '200px'};
      break;
    case 4:
      dimensions = isSmallScreen
        ? {width: '150px', height: '150px'}
        : {width: '300px', height: '300px'};
      break;
    case 5:
      dimensions = isSmallScreen
        ? {width: '125px', height: '150px'}
        : {width: '300px', height: '250px'};
      break;
    default:
      dimensions = {width: '300px', height: '300px'};
  }

  return (
    <Box
      sx={{
        width: dimensions.width,
        height: dimensions.height,
        backgroundColor: alpha(theme.palette.primary.light, 0.2),
        display: 'flex',
        marginRight: 2,
        marginTop: boxPosition === 'last' ? 0 : 2,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        ...borderRadius[boxPosition]
      }}
    >
      <CircularProgress />
      <ResponsiveTypography>{t(loadingLabel)}</ResponsiveTypography>
    </Box>
  );
};

export default MultimediaLoadingBox;
